export default class WizardStep {
  static TYPE_UPLOAD = 'upload';
  static TYPE_CLOUD = 'cloud';
  static TYPE_PROCESS = 'process';
  static TYPE_NONE = '';
  type = WizardStep.TYPE_NONE;

  name = '';
  title = '';
  subtitle = '';
  links = [];

  // Time estimate in minutes.
  estimate = 0.5;

  revenueUpdate;

  constructor(revenueUpdate, settings = {}) {
    this.revenueUpdate = revenueUpdate;
    Object.assign(this, settings);
  }

  getHtml() {
    return '';
  }

  getName() {
    return this.name;
  }

  getType() {
    return this.type;
  }

  hasForm() {
    return [WizardStep.TYPE_CLOUD, WizardStep.TYPE_UPLOAD].includes(this.getType());
  }

  getTitle() {
    return this.title;
  }

  getSubtitle() {
    return this.subtitle;
  }

  getHelpText() {
    return [];
  }

  getDownloadUrl() {
    return null;
  }

  getLinks() {
    let links = [];

    if (this.getDownloadUrl()) {
      links.push({
        label: `Download ${this.name} for date <strong>${this.getFormattedTarget()}</strong>`,
        url: this.getDownloadUrl()
      });
    }

    return links.concat(this.links);
  }

  getTargetHtml() {
    const target = this.getFormattedTarget();
    return `<span class="date">${target}</span>`;
  }

  getFormattedTarget() {
    return moment.tz(this.revenueUpdate.target, 'YYYY-MM', 'UTC').format('D MMM Y');
  }
}